import React from 'react';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button";
import Icon from "components/Selfcare/Common/Icon";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { ca } from 'date-fns/esm/locale';

import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';

//import UnderConstruction from "assets/img/Under-Construction.png";


class OverviewOtherSubscriptions extends React.Component {

    render() {
        const { customer, changeAdmin, adminNumber, administratedMsisdn, changeSetting, isAdmin, otherSubscriptions, parent, show, classes, t } = this.props;
        return (
            <div>
                    <div>
                        <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                            <GridContainer justify="center">
                                <GridItem xs={12} sm={12} md={10} lg={8}>
                                    <Icon name="family" size={48} color="#FFFFFF" />
                                    <div style={{ fontSize: '24px' }}>
                                    {customer && customer.TypeNo === '20' ?  t('selfcare:item.mycompany') : t('selfcare:item.myfamily')}
                                    </div>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                    <div style={{ paddingTop: '5px' }}>
                        <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={10} lg={8}>
                                <GridContainer justify="space-between" spacing={0}>
                                    <GridItem xs={12} md={6}>
                                        <div>
                                            <List>
                                            <ListSubheader style={{ color: '#e91e60', position: 'static' }}>{customer && customer.TypeNo === '20' ? t('selfcare:title.mycompany') : t('selfcare:title.myfamily')}</ListSubheader>
                                            <Divider component="li" />
                                            {otherSubscriptions && otherSubscriptions.map((s) => {
                                                return (
                                                    <React.Fragment key={s.FormattedMSISDN}>
                                                    <ListItem >
                                                        <ListItemText
                                                            primary={`${s.FormattedMSISDN} - ${s.Username}`}
                                                            secondary={s.Priceplan}
                                                        />
                                                            <ListItemSecondaryAction style={{ paddingRight: '20px', textAlign: 'right' }}>
                                                                {s.CanBeAdministrated && isAdmin ? s.FormattedMSISDN === administratedMsisdn ? <Button disabled size="sm">Administreres</Button> : <Button onClick={() => { adminNumber(s.Msisdn); }} color="rose" size="sm">{t('selfcare:button.administrate')}</Button> : <br/>}
                                                                <br/>
                                                                {s.CanBeAdministrated && isAdmin && <ToggleButtonGroup value={s.Administrator ? "true" : "false"} exclusive onChange={(e, value) => { changeAdmin(e, s.Msisdn, value); }}>
                                                                    <ToggleButton value="false" style={{ height: '25px' }}>
                                                                        {t('selfcare:button.user')}
                                                                    </ToggleButton>
                                                                    <ToggleButton value="true" style={{ height: '25px' }}>
                                                                        {t('selfcare:button.administrator')}
                                                                    </ToggleButton>
                                                                </ToggleButtonGroup>}
                                                                {!s.CanBeAdministrated && isAdmin && <ToggleButtonGroup value={s.Administrator ? "true" : "false"} exclusive onChange={(e, value) => { changeAdmin(e, s.Msisdn, value); }}>
                                                                    <ToggleButton disabled value="false" style={{ height: '25px' }}>
                                                                        {t('selfcare:button.user')}
                                                                    </ToggleButton>
                                                                    <ToggleButton disabled value="true" style={{ height: '25px' }}>
                                                                        {t('selfcare:button.administrator')}
                                                                    </ToggleButton>
                                                                </ToggleButtonGroup>}
                                                                {!isAdmin && <ToggleButtonGroup value={s.Administrator ? "true" : "false"} exclusive onChange={(e, value) => { changeAdmin(e, s.Msisdn, value); }}>
                                                                    <ToggleButton disabled value="false" style={{ height: '25px' }}>
                                                                        {t('selfcare:button.user')}
                                                                    </ToggleButton>
                                                                    <ToggleButton disabled value="true" style={{ height: '25px' }}>
                                                                        {t('selfcare:button.administrator')}
                                                                    </ToggleButton>
                                                                </ToggleButtonGroup>}
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                    <Divider component="li" />
                                                    </React.Fragment>
                                                )
                                            })}
                                            </List>
                                        </div>
                                    </GridItem>
                                <GridItem xs={12} md={6}>
                                        <List>
                                        <ListSubheader style={{ color: '#e91e60', position: 'static' }}>{t('selfcare:title.changes')}</ListSubheader>
                                            <ListItem style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                                <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        disabled={!isAdmin}
                                                        checked={customer.AllowServiceChanges}
                                                        onClick={(e) => { changeSetting(e, 'allowservice'); }}
                                                    />
                                                }
                                                label={t('selfcare:label.shouldallowservicechanges')}
                                            labelPlacement="end"
                                        />
                                            </ListItem>
                                            <ListItem style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                                <FormControlLabel
                                                    control={
                                                    <Checkbox
                                                        disabled={!isAdmin}
                                                        checked={customer.AllowPriceplanChanges}
                                                        onClick={(e) => { changeSetting(e, 'allowpriceplan'); }}
                                                        />
                                                    }
                                                label={t('selfcare:label.shouldallowsubscriptionchanges')}
                                        labelPlacement="end"
                                    />
                                            </ListItem>
                                        <ListSubheader style={{ color: '#e91e60', position: 'static' }}>{t('selfcare:title.notification-by-email')}</ListSubheader>
                                            <ListItem style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                                <FormControlLabel
                                                    control={
                                                    <Checkbox
                                                        disabled={!isAdmin}
                                                        checked={customer.NotifyAddressChanges}
                                                        onClick={(e) => { changeSetting(e, 'notifyaddress'); }}
                                                        />
                                                    }
                                                label={t('selfcare:label.notifystaffchanges')}
                                                    labelPlacement="end"
                                                />
                                            </ListItem>
                                            <ListItem style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                                <FormControlLabel
                                                    control={
                                                    <Checkbox
                                                        disabled={!isAdmin}
                                                        checked={customer.NotifyPriceplanChanges}
                                                        onClick={(e) => { changeSetting(e, 'notifypriceplan'); }}
                                                        />
                                                    }
                                                label={t('selfcare:label.notifysubscriptionchanges')}
                                                    labelPlacement="end"
                                                />
                                            </ListItem>
                                            <ListItem style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                                                <FormControlLabel
                                                    control={
                                                    <Checkbox
                                                        disabled={!isAdmin}
                                                        checked={customer.NotifyServiceChanges}
                                                        onClick={(e) => { changeSetting(e, 'notifyservice'); }}
                                                        />
                                                    }
                                                label={t('selfcare:label.notifyservicechanges')}
                                                    labelPlacement="end"
                                                />
                                            </ListItem>
                                        </List>
                                        <table style={{ padding: '10px' }}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div style={{ fontSize: '1.3125rem', paddingBottom: '5px' }}>
                                                        {t('selfcare:info.needhelp')}
                                                </div>
                                                    <div>
                                                        <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.contact') }} />
                                                </div>
                                                    </td>
                                                    <td>
                                                        <Icon name="help" size={64} color="#e91e60" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                    </GridContainer>
                    </div>
            </div>
        );
    }
}

OverviewOtherSubscriptions.propTypes = {
    parent: PropTypes.object,
    subscription: PropTypes.object,
};

export default compose(
    withTranslation(),
)(OverviewOtherSubscriptions);
